export function getCurrencySymbol(currency: string): string {
  switch (currency) {
    case 'usd':
      return '$';
    case 'eur':
      return '€';
    case 'aed':
      return 'AED';
    case 'rub':
      return '₽';
    case 'kzt':
      return '₸';
    case 'usdt':
      return 'usdt';
    case 'ton':
      return 'ton';
    case 'uzs':
      return 'uzs';
    default:
      return currency;
  }
}
